<div class="d-flex align-items-start justify-between flex-gap-3 border-radius-lg border background-secondary p-3">
  @if (showIcon()) {
    <div class="mw-25">
      <svg
        width="60"
        height="57"
        viewBox="0 0 60 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6_8676)">
          <g clip-path="url(#clip1_6_8676)">
            <path
              d="M16.1196 20.3594C16.1196 16.4934 19.2536 13.3594 23.1196 13.3594H53.0002C56.8662 13.3594 60.0002 16.4934 60.0002 20.3594V50C60.0002 53.866 56.8662 57 53.0002 57H23.1196C19.2536 57 16.1196 53.866 16.1196 50V20.3594Z"
              fill="#F9F9F9" />
            <path
              d="M53.0005 55V57H23.1196V55H53.0005ZM58.0005 50V20.3594C58.0005 17.598 55.7618 15.3595 53.0005 15.3594H23.1196C20.3582 15.3594 18.1196 17.598 18.1196 20.3594V50C18.1196 52.7614 20.3582 55 23.1196 55V57L22.7593 56.9912C19.0607 56.8037 16.1196 53.7451 16.1196 50V20.3594C16.1196 16.4934 19.2536 13.3594 23.1196 13.3594H53.0005L53.3608 13.3682C57.0593 13.5558 60.0005 16.6143 60.0005 20.3594V50L59.9907 50.3604C59.8092 53.9394 56.9399 56.8096 53.3608 56.9912L53.0005 57V55C55.7618 54.9999 58.0005 52.7613 58.0005 50Z"
              fill="#252525" />
            <path
              d="M8.05957 14.125C8.05957 10.259 11.1936 7.125 15.0596 7.125H44.9402C48.8062 7.125 51.9402 10.259 51.9402 14.125V43.7656C51.9402 47.6316 48.8062 50.7656 44.9402 50.7656H15.0596C11.1936 50.7656 8.05957 47.6316 8.05957 43.7656V14.125Z"
              fill="#F9F9F9" />
            <path
              d="M44.9404 48.7656V50.7656H15.0596V48.7656H44.9404ZM49.9404 43.7656V14.125C49.9404 11.3637 47.7017 9.12514 44.9404 9.125H15.0596C12.2981 9.125 10.0596 11.3636 10.0596 14.125V43.7656C10.0596 46.5271 12.2981 48.7656 15.0596 48.7656V50.7656L14.6992 50.7568C11.0007 50.5693 8.05957 47.5108 8.05957 43.7656V14.125C8.05957 10.259 11.1936 7.125 15.0596 7.125H44.9404L45.3008 7.13379C48.9992 7.32146 51.9404 10.3799 51.9404 14.125V43.7656L51.9307 44.126C51.7492 47.7051 48.8798 50.5752 45.3008 50.7568L44.9404 50.7656V48.7656C47.7017 48.7655 49.9404 46.527 49.9404 43.7656Z"
              fill="#252525" />
            <path
              d="M0 7C0 3.13401 3.13401 0 7 0H36.8806C40.7466 0 43.8806 3.13401 43.8806 7V36.6406C43.8806 40.5066 40.7466 43.6406 36.8806 43.6406H7C3.134 43.6406 0 40.5066 0 36.6406V7Z"
              fill="#F9F9F9" />
            <path
              d="M36.8809 41.6406V43.6406H7V41.6406H36.8809ZM41.8809 36.6406V7C41.8809 4.23866 39.6422 2.00014 36.8809 2H7C4.23858 2 2 4.23858 2 7V36.6406C2 39.4021 4.23858 41.6406 7 41.6406V43.6406L6.63965 43.6318C2.94111 43.4443 0 40.3858 0 36.6406V7C0 3.13401 3.13401 0 7 0H36.8809L37.2412 0.00878906C40.9396 0.196459 43.8809 3.25495 43.8809 7V36.6406L43.8711 37.001C43.6896 40.5801 40.8203 43.4502 37.2412 43.6318L36.8809 43.6406V41.6406C39.6422 41.6405 41.8809 39.402 41.8809 36.6406Z"
              fill="#252525" />
          </g>
          <path
            d="M3.58203 8.00781C3.58203 5.79867 5.37289 4.00781 7.58203 4.00781H36.2984C38.5076 4.00781 40.2984 5.79867 40.2984 8.00781V10.6953C40.2984 12.9045 38.5076 14.6953 36.2984 14.6953H7.58203C5.37289 14.6953 3.58203 12.9045 3.58203 10.6953V8.00781Z"
            fill="#2D6CA2"
            fill-opacity="0.2" />
          <path
            d="M3.58203 20.4766C3.58203 18.2674 5.37289 16.4766 7.58203 16.4766H36.2984C38.5076 16.4766 40.2984 18.2674 40.2984 20.4766V23.1641C40.2984 25.3732 38.5076 27.1641 36.2984 27.1641H7.58203C5.37289 27.1641 3.58203 25.3732 3.58203 23.1641V20.4766Z"
            fill="#2D6CA2"
            fill-opacity="0.2" />
          <path
            d="M3.58203 32.9453C3.58203 30.7362 5.37289 28.9453 7.58203 28.9453H36.2984C38.5076 28.9453 40.2984 30.7362 40.2984 32.9453V35.6328C40.2984 37.842 38.5076 39.6328 36.2984 39.6328H7.58203C5.37289 39.6328 3.58203 37.842 3.58203 35.6328V32.9453Z"
            fill="#2D6CA2"
            fill-opacity="0.2" />
        </g>
        <defs>
          <clipPath id="clip0_6_8676">
            <rect
              width="60"
              height="57"
              fill="white" />
          </clipPath>
          <clipPath id="clip1_6_8676">
            <rect
              width="60.0005"
              height="57"
              fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  }

  <div>
    <ng-content></ng-content>
  </div>
</div>
